// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"export"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M10 3H3V21H21V15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10.5 14.75L10.5 11.5C10.5 8.73857 12.7386 6.5 15.5 6.5L21 6.49999M19 10L22.5 6.49999L19 3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-export')
export default class ExportIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'export',
    }
  }
}
